import Markdown from "markdown-to-jsx";
import HighlightCard from 'components/pages/CasaVerdeAmarela/HighlightCard'
import Image from 'next/image'
import styles from "./vocacao.module.css";


export default function Vantagens({ data }) {
  return (
    <>
      <section className={`container-full`} style={{ backgroundColor: data.itens[0].background_color }}>
        <div className={`flex-column flex-lg-row ${styles.content}`}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <h2>{data.titulo}</h2>
          </div>
          <div className={styles.descricao}>
            <p>{data.itens[0].titulo}</p>
            <div className={styles.markContent}>
              <Markdown>{data.itens[0].descricao}</Markdown>
            </div>
          </div>
        </div>
      </section>
      <section className={`container-full`} style={{ backgroundColor: data.itens[1].background_color }}>
        <div className={`flex-column flex-lg-row ${styles.content}`}>
          <div className={styles.descricao}>
            <p>{data.itens[1].titulo}</p>
            <div className={styles.markContent}>
              <Markdown>{data.itens[1].descricao}</Markdown>
            </div>
            <div className={styles.cardsContent}>
              {
                data.itens[1].cards.map((item, index) => {
                  return (
                    <HighlightCard data={item} />
                  )
                })
              }
            </div>
          </div>
        </div>
      </section>

      <section className={`container-full`} style={{ backgroundColor: data.itens[2].background_color }}>
        <div className={`flex-column flex-lg-row`}>
          <div className={styles.descContent}>
            <div
              className={styles.descricaoRow}
              style={{ paddingLeft: '28px', paddingRight: '28px' }}
            >
              <p>{data.itens[2].titulo}</p>
              <div className={styles.markContent}>
                <Markdown>{data.itens[2].descricao}</Markdown>
              </div>
            </div>
            <div className={styles.mobileIcon}>
              <Image
                src={data.itens[2].cards[0].imagem_card.url}
                width={342}
                height={301}
                objectFit="contain"
                responsive
              />
            </div>
          </div>
        </div>
      </section>

      <section className={`container-full`} style={{ backgroundColor: data.itens[3].background_color }}>
        <div className={`flex-column flex-lg-row`}>
          <div className={styles.descContent}>
            <div className={styles.mobileIcon}>
              <Image
                src={data.itens[3].cards[0].imagem_card.url}
                width={210}
                height={210}
                objectFit="contain"
                responsive
              />
            </div>
            <div
              className={`${styles.descricaoRow}`}
              style={{ paddingLeft: '28px', paddingRight: '28px' }}
            >
              <p>{data.itens[3].titulo}</p>
              <div className={styles.markContent}>
                <Markdown>{data.itens[3].descricao}</Markdown>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className={`container-full`} style={{ backgroundColor: data.itens[4].background_color }}>
        <div className={`flex-column flex-lg-row`}>
          <div className={styles.descContent}>
            <div
              className={styles.descricaoRow}
              style={{ paddingLeft: '28px', paddingRight: '28px' }}
            >
              <p>{data.itens[4].titulo}</p>
              <div className={styles.markContent}>
                <Markdown>{data.itens[4].descricao}</Markdown>
              </div>
            </div>
            <div className={styles.mobileIcon}>
              <Image
                src={data.itens[4].cards[0].imagem_card.url}
                width={243}
                height={243}
                objectFit="contain"
                responsive
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
